export const MODE_AFFICHAGE_DIFFUSION_TOUJOURS = "always";
export const MODE_AFFICHAGE_DIFFUSION_CONNECTE = "connected";
export const MODE_AFFICHAGE_DIFFUSION_DECONNECTE = "anonymous";

export const MODES_AFFICHAGE_DIFFUSION = Object.freeze ([
  MODE_AFFICHAGE_DIFFUSION_TOUJOURS,
  MODE_AFFICHAGE_DIFFUSION_CONNECTE,
  MODE_AFFICHAGE_DIFFUSION_DECONNECTE,
]);

export const OPTIONS_MODE_AFFICHAGE_DIFFUSION = Object.freeze ([
  {value : MODE_AFFICHAGE_DIFFUSION_TOUJOURS, label : "Toujours"},
  {value : MODE_AFFICHAGE_DIFFUSION_CONNECTE, label : "Mode connecté"},
  {value : MODE_AFFICHAGE_DIFFUSION_DECONNECTE, label : "Mode déconnecté"},
]);

export function normalise_mode_affichage_diffusion (pValeur)
  {
    const tValeur = typeof pValeur === "string" ? pValeur.trim () : "";
    return MODES_AFFICHAGE_DIFFUSION.includes (tValeur)
      ? tValeur
      : MODE_AFFICHAGE_DIFFUSION_TOUJOURS;
  }

export function mode_affichage_diffusion_est_visible (pValeur, pConnecte = false)
  {
    const tMode = normalise_mode_affichage_diffusion (pValeur);
    if (tMode === MODE_AFFICHAGE_DIFFUSION_CONNECTE) return !!pConnecte;
    if (tMode === MODE_AFFICHAGE_DIFFUSION_DECONNECTE) return !pConnecte;
    return true;
  }
